
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class VideoBackdropEffect extends BaseParallaxEffect implements ParallaxEffect {
    private static videoCache: Map<string, HTMLVideoElement> = new Map();

    public render(pc: ParallaxContext): void {
        const { ctx, config, width, height } = pc;
        const url = config.parallaxVideoUrl;
        if (!url) return;

        let video = VideoBackdropEffect.videoCache.get(url);
        if (!video) {
            video = document.createElement('video');
            video.src = url;
            video.loop = true;
            video.muted = true;
            video.play().catch(e => console.warn("Video play failed", e));
            VideoBackdropEffect.videoCache.set(url, video);
        }

        if (video.readyState >= 2) {
            ctx.save();
            ctx.globalAlpha *= (config.parallaxMediaOpacity || 1.0);
            
            const fit = config.parallaxMediaFit || 'COVER';
            this.drawVideo(ctx, video, width, height, fit);
            
            ctx.restore();
        }
    }

    private drawVideo(ctx: CanvasRenderingContext2D, video: HTMLVideoElement, w: number, h: number, fit: string) {
        let dx = -w/2, dy = -h/2, dw = w, dh = h;
        const videoAspect = video.videoWidth / video.videoHeight;
        const screenAspect = w / h;

        if (fit === 'COVER') {
            if (videoAspect > screenAspect) {
                dw = h * videoAspect;
                dx = -dw / 2;
            } else {
                dh = w / videoAspect;
                dy = -dh / 2;
            }
        } else if (fit === 'CONTAIN') {
            if (videoAspect > screenAspect) {
                dh = w / videoAspect;
                dy = -dh / 2;
            } else {
                dw = h * videoAspect;
                dx = -dw / 2;
            }
        }

        ctx.drawImage(video, dx, dy, dw, dh);
    }
}
